var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpectral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4743_52458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 10.5049L12.5996 36.0501L20.5658 32.8951L27.9997 20.5711V10.5049Z",
    fill: "url(#paint0_linear_4743_52458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 20.5713L20.5664 32.8953L28.0002 36.9967V20.5713Z",
    fill: "url(#paint1_linear_4743_52458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5658 32.8955L12.5996 36.0505L27.9997 44.6575V36.9969L20.5658 32.8955Z",
    fill: "url(#paint2_linear_4743_52458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 10.5049L43.4001 36.0501L35.4338 32.8951L28 20.5711V10.5049Z",
    fill: "url(#paint3_linear_4743_52458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 20.5713L35.4338 32.8953L28 36.9967V20.5713Z",
    fill: "url(#paint4_linear_4743_52458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4338 32.8955L43.4001 36.0505L28 44.6575V36.9969L35.4338 32.8955Z",
    fill: "url(#paint5_linear_4743_52458)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E0E5EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4743_52458",
    x1: 20.3006,
    y1: 36.054,
    x2: 20.3006,
    y2: 10.5088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F9972E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#005FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4743_52458",
    x1: 24.2814,
    y1: 36.9928,
    x2: 24.2814,
    y2: 20.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EE4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDD54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E1E18B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4743_52458",
    x1: 20.2996,
    y1: 44.6536,
    x2: 20.2996,
    y2: 32.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E00F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ED3D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4743_52458",
    x1: 35.6991,
    y1: 36.054,
    x2: 35.6991,
    y2: 10.5088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9944D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FCCE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D3D5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00C9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4743_52458",
    x1: 31.7179,
    y1: 36.9928,
    x2: 31.7179,
    y2: 20.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F9844A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FCDB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4743_52458",
    x1: 35.6991,
    y1: 44.6536,
    x2: 35.6991,
    y2: 32.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F41D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA138"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4743_52458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.8002,
    height: 34.1523,
    fill: "white",
    transform: "translate(12.5996 10.5049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectral);
export default __webpack_public_path__ + "static/media/spectral.a7253c9f8bdbced332a8020a22275712.svg";
export { ForwardRef as ReactComponent };